/**
 * RefundSlice State Definition
 * 
 * Contains the interface and initial state for the refund slice.
 */

import { RefundView } from '../types/refundTypes';

export interface RefundSliceState {
  currentRefund: RefundView | null;
  isEdited: boolean;
  editedFields: string[];
  validationErrors: Record<string, string>;
}

export const initialState: RefundSliceState = {
  currentRefund: null,
  isEdited: false,
  editedFields: [],
  validationErrors: {},
};
